import { useEffect, useState } from 'react';

/**
 * Accepts an object, and returns the result of that object if its values change.
 * Avoids re-rendering by comparing objects by top level values instead of by reference equality.
 *
 * Note - if the top level value is an object, it will be compared by reference equality, not by value.
 * Avoid using this hook in this case
 * TODO can we make this work for objects by using a deep comparison instead?
 */
export const useHookResult = <T extends object>(freshResult: T) => {
  const [result, setResult] = useState<T>(freshResult);

  useEffect(
    () => setResult(freshResult),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- dependency list can't be statically checked
    Object.values(freshResult),
  );

  return result;
};
